import React from 'react';
import { useAuth } from '../../context/AuthContext';
import EspaceEmployePage from './EspaceEmployePage';

// « Mon espace » : l'espace salarié affiché pour le compte nominatif connecté.
// Même écran que l'accès par code personnel, mais sans code à saisir.
export default function MonEspacePage() {
  const { logout } = useAuth();
  return (
    <div className="-m-4 sm:-m-6">
      <EspaceEmployePage auto onLogout={logout} />
    </div>
  );
}
